import * as Yup from 'yup';

export const addFinishedProductValidation = {
   productNames:Yup.array().required('Please enter productNames name.'),
    quantity: Yup.string().trim(),
    /*unitId:Yup.number()
        .required('Please enter unit i.')
 */
}
